import { NegotiationRoundStatus, SourcingEventStatus, type NegotiationRoundV2Dto } from "../../../../autogen/bff-api";

/**
 * Whether the buyer may pick a winner yet.
 *
 * Picking a winner is the conclusion of the evaluation, not a shortcut past it — while the event is
 * being evaluated the scores and the product basket are still moving. A negotiated competition is
 * the exception in form only: it stays in EVALUATION until it is awarded and signals a finished
 * evaluation by completing its rounds, so completed rounds count the same as a completed event.
 *
 * Shared by the award tab and the bid detail's winner button, which only navigates there — gating
 * one without the other would leave a button pointing at a screen that refuses to act on it.
 */
export const canSelectWinner = (
  status: SourcingEventStatus,
  rounds: readonly NegotiationRoundV2Dto[],
): boolean => {
  if (status !== SourcingEventStatus.Evaluation) return true;
  return rounds.length > 0 && rounds.every((round) => round.status === NegotiationRoundStatus.Completed);
};
